var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserHelmet = function SvgUserHelmet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 44 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#userHelmet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.226 0a2.327 2.327 0 0 0-2.321 2.344v5.469l-2.747-5.557A12.53 12.53 0 0 0 9.638 12.5H9.62a2.327 2.327 0 0 0-2.321 2.344 2.327 2.327 0 0 0 2.321 2.344h24.762a2.327 2.327 0 0 0 2.321-2.344 2.327 2.327 0 0 0-2.321-2.344h-.02a12.53 12.53 0 0 0-6.519-10.244l-2.747 5.557v-5.47A2.327 2.327 0 0 0 22.774 0zm-7.893 34.375c-7.177 0-13 5.879-13 13.125 0 1.377 1.113 2.5 2.477 2.5h38.38c1.364 0 2.477-1.123 2.477-2.5 0-7.246-5.823-13.125-13-13.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.716 17.188a12 12 0 0 0-.097 1.562c0 6.904 5.543 12.5 12.381 12.5 6.839 0 12.381-5.596 12.381-12.5 0-.527-.029-1.055-.097-1.562z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "userHelmet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.333 0h43.333v50H.333z"
  })))));
};
export default SvgUserHelmet;